import { GeoJsonLineWithHalo } from "./GeoJsonLineWithHalo";
import {
  useRouteResponse,
  useRouteStoreActions,
  useSelectedRouteIndex,
} from "../../stores/RouteStore";

export default function ObstructedRoute() {
  const routeResponse = useRouteResponse();
  const selectedRouteIndex = useSelectedRouteIndex();
  const routeStoreActions = useRouteStoreActions();

  if (!routeResponse || routeResponse.routes.length === 0) {
    return <></>;
  }

  return (
    <>
      {routeResponse.routes.map((route, index) => {
        if (index !== selectedRouteIndex && route.isObstructed) {
          return (
            <GeoJsonLineWithHalo
              key={route.routeId}
              data={route}
              color="#FC7878"
              haloColor="#000000"
              weight={3}
              onEachFeature={(feature, layer) => {
                layer.on("click", () => {
                  routeStoreActions.setSelectedRouteIndex(index);
                });
              }}
            />
          );
        }
      })}
    </>
  );
}
